import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getHomeVideos } from "../../redux/actions/postActions";
import Avatar from "../../components/avatar/Avatar";
import "./VideosList.css";
import { Link } from "react-router-dom";
import { IonIcon, useIonRouter } from "@ionic/react";
import { chevronForward } from "ionicons/icons";
import { PiFilmSlateFill } from "react-icons/pi";
import { loonlogAvatarSvg } from "../avatar/Avatar2";
const VideosList = () => {
  const getVideoUrl = (media = []) =>
    media.find((url) => /\.(mp4|mov|webm|avi|mkv)(\?.*)?$/i.test(url));
  const dispatch = useDispatch();
  const history = useHistory();
  const router = useIonRouter();
  const { homeVideos } = useSelector((state) => state.post);
  const { avatar, username, province } = useSelector(
    (state) => state.currentProfile.data,
  );

  useEffect(() => {
    dispatch(getHomeVideos());
  }, [dispatch]);

  const handleVideoClick = (postId) => {
    router.push(`/videos?id=${postId}`);
  };
  const handleAllVideosClick = () => {
    router.push("/videos");
  };
  if (!homeVideos || homeVideos.length === 0) {
    return null;
  }

  return (
    <div className="video-list-wrapper">
      <div className="video-list-header">
        <div className="videos-list-header-title">
          <PiFilmSlateFill size={5} className="videos-list-header-icon" />
          <span>LoonClips</span>
        </div>

        <Link to="/videos" className="video-list-header-link">
          <span>See all</span>
          <IonIcon icon={chevronForward} />
        </Link>
      </div>
      <div className="videos-list-container">
        <div className="videos-list-scroll">
          <Link className="story-card" to="/new-post?mode=video">
            <div className="image-container">
              <img
                src={avatar ? avatar : loonlogAvatarSvg(username, province)}
                alt="create clip"
                className="profile-img"
              />
            </div>
            <div className="footer">
              <div className="add-button-container">
                <div className="plus-icon">+</div>
              </div>
              <span className="footer-text"> LoonClip</span>
            </div>
          </Link>
          {/* {homeVideos.map((video, index) => (
            <div
              key={video._id}
              className="video-thumb-card"
              onClick={() => handleVideoClick(video._id)}
            >
              <div className="video-thumb-avatar">
                <Avatar
                  username={video.author?.username}
                  avatar={video.author?.avatar}
                  province={video.author?.province}
                  size={32}
                  className="video-avatar-custom"
                  // isOfficial={video.author?.isAdmin}
                />
              </div>
              {index === 0 ? (
                <video
                  className="video-thumb-media"
                  playsInline
                  muted
                  loop
                  autoPlay
                  preload="metadata"
                >
                  <source src={video.media[0]} type={video.media[0].type} />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  className="video-thumb-media"
                  src={
                    video.media[0]?.split("?")[0].replace(/\.[^/.]+$/, "") +
                    "-thumb.jpg"
                  }
                  alt="Video thumbnail"
                />
              )}{" "}
              <div className="video-thumb-overlay"></div>
              <div className="video-thumb-username">
                {video.author?.username || "unknown"}
              </div>
            </div>
          ))} */}
          {homeVideos.map((video, index) => {
            const videoUrl = getVideoUrl(video.media);

            if (!videoUrl) return null;

            const thumbnailUrl =
              videoUrl.split("?")[0].replace(/\.[^/.]+$/, "") + "-thumb.jpg";

            return (
              <div
                key={video._id}
                className="video-thumb-card"
                onClick={() => handleVideoClick(video._id)}
              >
                <div className="video-thumb-avatar">
                  <Avatar
                    username={video.author?.username}
                    avatar={video.author?.avatar}
                    province={video.author?.province}
                    size={32}
                    className="video-avatar-custom"
                  />
                </div>

                {index === 0 ? (
                  <video
                    className="video-thumb-media"
                    playsInline
                    muted
                    loop
                    autoPlay
                    preload="metadata"
                    src={videoUrl}
                  />
                ) : (
                  <img
                    className="video-thumb-media"
                    src={thumbnailUrl}
                    alt="Video thumbnail"
                  />
                )}

                <div className="video-thumb-overlay" />

                <div className="video-thumb-username">
                  {video.author?.username || "unknown"}
                </div>
              </div>
            );
          })}
          {/* Replace the old View All div with this */}
          {/* <div
            className="video-thumb-card video-thumb-view-all"
            onClick={handleAllVideosClick}
          >
            <div className="view-all-content">
              <div className="view-all-icon-circle">
                 <IonIcon icon={chevronForward} />
              </div>
              <span className="view-all-text">View All</span>
            </div>

            <div className="view-all-overlay"></div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VideosList;
